import { Checkbox, Flex, Form, message } from "antd";
import "./AreaCode.scss";
import NormalButton from "../../../Reuseable/NormalButton/NormalButton";
import CustomSelect from "../../../Reuseable/Select/Select";
import { useDispatch, useSelector } from "react-redux";
import { createAreaCodes } from "../../../assets/api/agency";
import CustomNotification from "../../../Reuseable/CustomNotification/CustomNotification";
import { useState } from "react";
import { fetchBankAreaCodes } from "../../../store/agencySlice";

const AreaFilterForm = ({ bankData = [], areaData = [] }) => {
  const [form] = Form.useForm();
  const token = useSelector((state) => state.auth.token);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleSubmit = async (values) => {
    const payload = {
      portfolio: values.bank,
      area_code: values.pincode,
      status: values.status || false,
    };
    setLoading(true);

    try {
      const res = await createAreaCodes(payload, token);

      CustomNotification.show(res?.message, "success");
      setLoading(false);
      form.resetFields();
       dispatch(fetchBankAreaCodes());
    } catch (error) {
      CustomNotification.show(
        error?.message || "Failed to create area codes",
        "error"
      );
      setLoading(false);
    }
  };

  const bankOptions =
    bankData.map((item) => ({
      label: item.name,
      value: item.id,
    })) || [];

  const areaOptions =
    areaData.map((item) => ({
      label: item.areacode,
      value: item.id,
    })) || [];
  return (
    <div className="filterFormContainer">
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        className="filterForm"
      >
        <Flex className="formFlexFirst" gap={16}>
          <Form.Item
            label="Bank"
            name="bank"
            className="formItem"
            required={false}
            rules={[{ required: true, message: "Please select bank" }]}
          >
            <CustomSelect
              placeholder="Select Bank(s)"
              className="formSelect"
              options={bankOptions}
              isMultiSelect={false}
            />
          </Form.Item>

          <Form.Item
            label="Area Code"
            name="pincode"
            className="formItem"
            required={false}
            rules={[{ required: true, message: "Please select area codes" }]}
          >
            <CustomSelect
              placeholder="Select Area Codes"
              className="formSelect"
              options={areaOptions}
              isMultiSelect={false}
            />
          </Form.Item>
        </Flex>

        <Flex className="formFlexSecond" gap={16} align="center">
          <Form.Item name="status" valuePropName="checked" className="formItem">
            <Checkbox className="formCheckbox">Status</Checkbox>
          </Form.Item>

          <Form.Item className="formItem">
            <NormalButton
              type="primary"
              htmlType="submit"
              className="submitBtn"
              loading={loading}
            >
              Submit
            </NormalButton>
          </Form.Item>
        </Flex>
      </Form>
    </div>
  );
};

export default AreaFilterForm;
